// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cRUK","type":"styles_type__3itUr","choices":"styles_choices__3g0GS"};